<div class="flex flex-col h-full min-h-0 w-full bg-gray-50 mt-2 border border-solid border-gray-200 rounded-lg overflow-hidden" tabindex="-1">
  <!-- Cabeçalho laranja (container): título + atualizar -->
  <div class="shrink-0 flex items-center justify-between gap-2 px-3 py-2 bg-orange-600 text-white rounded-t-lg" tabindex="-1">
    <h2 class="text-lg font-semibold">Mesas</h2>
    <div class="flex items-center gap-2">
      <button
        type="button"
        (click)="loadData()"
        [disabled]="loading"
        class="p-1.5 rounded hover:bg-orange-700 disabled:opacity-50"
        title="Atualizar"
        tabindex="-1"
      >
        <i class="pi pi-refresh text-lg"></i>
      </button>
    </div>
  </div>

  <!-- Busca: ícone dentro do input -->
  <div class="shrink-0 px-3 py-2 bg-white" tabindex="-1">
    <div class="relative w-full" tabindex="-1">
      <input
        [(ngModel)]="searchMesa"
        (ngModelChange)="applyFilter()"
        type="text"
        pInputText
        class="w-full text-sm pl-9"
        placeholder="Procurar mesa"
        tabindex="-1"
      />
    </div>
  </div>

  <!-- Conteúdo: grid de quadrados -->
  <div class="flex-1 min-h-0 overflow-y-auto p-3" tabindex="-1">
    <p *ngIf="loading" class="text-gray-600 text-sm py-4" tabindex="-1">Carregando mesas...</p>

    <div *ngIf="!loading && tablesFiltered.length === 0" class="text-gray-500 text-sm py-4" tabindex="-1">
      {{ searchMesa ? 'Nenhuma mesa encontrada.' : 'Nenhuma mesa cadastrada.' }}
    </div>

    <div *ngIf="!loading && tablesFiltered.length > 0" class="grid grid-cols-3 gap-2" tabindex="-1">
      <button
        *ngFor="let row of tablesFiltered"
        type="button"
        (click)="selectTable(row)"
        class="flex flex-col items-center justify-center rounded-lg transition-all min-h-[4.5rem] text-center cursor-pointer"
        [ngClass]="getBoxClasses(row)"
        tabindex="-1"
      >
        <span class="font-bold text-lg leading-tight">{{ row.table.number }}</span>
        <span *ngIf="row.comandaObservation" class="text-xs mt-0.5 truncate w-full px-1 opacity-95">
          {{ row.comandaObservation }}
        </span>
      </button>
    </div>
  </div>

  <!-- Legenda + Ações: mesma altura que a direita (barra Cliente h-12 + totais h-24 = h-36) para alinhar com os totais -->
  <div class="shrink-0 flex flex-col border-t border-gray-200 min-h-[9rem]" tabindex="-1">
    <div class="shrink-0 flex flex-wrap items-center justify-center gap-4 px-3 py-2 bg-white text-xs text-gray-600" tabindex="-1">
      <span class="flex items-center gap-1.5">
        <span class="w-3 h-3 rounded bg-emerald-500"></span> Livre
      </span>
      <span class="flex items-center gap-1.5">
        <span class="w-3 h-3 rounded bg-red-500"></span> Consumindo
      </span>
      <span class="flex items-center gap-1.5">
        <span class="w-3 h-3 rounded bg-blue-500"></span> Reservado
      </span>
    </div>
    <div class="flex-1 px-3 py-2 bg-gray-100 flex flex-col justify-center gap-1.5" tabindex="-1">
      <div class="flex gap-2" tabindex="-1">
        <button
          (click)="abrirComanda()"
          [disabled]="!selectedTable || loadingOpenComanda"
          class="flex-1 py-2 rounded-lg font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed bg-emerald-600 text-white hover:bg-emerald-700"
          tabindex="-1"
        >
          {{ loadingOpenComanda ? '...' : 'Abrir comanda' }}
        </button>
        <button
          (click)="abrirModalAdicionarItens()"
          [disabled]="!selectedTable"
          class="flex-1 py-2 rounded-lg font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed bg-indigo-600 text-white hover:bg-indigo-700"
          tabindex="-1"
        >
          Adicionar itens
        </button>
      </div>
      <div class="flex gap-2" tabindex="-1">
        <button
          (click)="consultarComanda()"
          [disabled]="!selectedTable || loadingConsulta"
          class="flex-1 py-2 rounded-lg font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed bg-gray-600 text-white hover:bg-gray-700"
          tabindex="-1"
        >
          {{ loadingConsulta ? '...' : 'Consultar comanda' }}
        </button>
        <button
          (click)="fecharComanda()"
          [disabled]="!selectedTable || loadingComanda"
          class="flex-1 py-2 rounded-lg font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed bg-orange-600 text-white hover:bg-orange-700"
          tabindex="-1"
        >
          {{ loadingComanda ? '...' : 'Fechar comanda' }}
        </button>
      </div>
      <p *ngIf="!selectedTable" class="text-xs text-gray-500 text-center" tabindex="-1">
        Selecione uma mesa.
      </p>
    </div>
  </div>
</div>

<!-- Modal: Consulta da comanda (itens e total) -->
<p-dialog
  [(visible)]="comandaModalVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeComandaModal()"
  [header]="'Comanda - Mesa ' + mesaNumberForModal"
  [style]="{ width: '420px' }"
  styleClass="p-dialog-sm"
  tabindex="-1"
>
  <div *ngIf="comandaForModal" class="flex flex-col gap-3" tabindex="-1">
    <p-table [value]="comandaForModal.items" [paginator]="false" styleClass="p-datatable-sm p-datatable-gridlines" class="text-sm" tabindex="-1">
      <ng-template pTemplate="header">
        <tr class="bg-gray-100">
          <th class="text-left p-2">Produto</th>
          <th class="text-right p-2">Qtd</th>
          <th class="text-right p-2">Unit.</th>
          <th class="text-right p-2">Total</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="p-2">{{ item.productName || '-' }}</td>
          <td class="text-right p-2">{{ item.quantity | number:'1.0-2' }}</td>
          <td class="text-right p-2">{{ item.unitPrice | currency:'BRL' }}</td>
          <td class="text-right p-2">{{ item.total | currency:'BRL' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="4" class="text-center p-4 text-gray-500">Nenhum item na comanda.</td></tr>
      </ng-template>
    </p-table>
    <div class="flex justify-between items-center border-t pt-2 font-semibold" tabindex="-1">
      <span>Total gasto</span>
      <span>{{ comandaForModal.total | currency:'BRL' }}</span>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" pButton label="Fechar" class="p-button-secondary" (click)="closeComandaModal()" tabindex="-1"></button>
  </ng-template>
</p-dialog>

<!-- Modal: Adicionar itens na comanda -->
<p-dialog
  [(visible)]="addItemsModalVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeAddItemsModal()"
  [header]="'Adicionar itens - Mesa ' + (selectedTable?.table?.number || '-')"
  [style]="{ width: '720px' }"
  styleClass="p-dialog-lg"
  tabindex="-1"
>
  <div *ngIf="comandaForEdit" class="flex flex-col gap-3" tabindex="-1">
    <div class="grid grid-cols-12 gap-2 items-end">
      <div class="col-span-12 md:col-span-6">
        <label class="block text-sm font-medium mb-1">Produto</label>
        <input
          [(ngModel)]="productSearch"
          (input)="onProductSearchChange()"
          pInputText
          type="text"
          class="w-full"
          placeholder="Digite para pesquisar produto"
        />
        <div *ngIf="loadingProductSearch" class="text-xs text-gray-500 mt-1">Buscando...</div>
        <div *ngIf="productSearchResults.length > 0" class="mt-1 border rounded max-h-36 overflow-auto bg-white">
          <button
            *ngFor="let product of productSearchResults"
            type="button"
            (click)="selectProduct(product)"
            class="w-full text-left px-2 py-1 text-sm hover:bg-orange-50 cursor-pointer"
          >
            {{ product.code }} - {{ product.description }}
          </button>
        </div>
      </div>
      <div class="col-span-12 md:col-span-2">
        <label class="block text-sm font-medium mb-1">Qtd</label>
        <input
          [(ngModel)]="itemQuantity"
          pInputText
          type="number"
          min="0.01"
          step="0.01"
          class="w-full"
        />
      </div>
      <div class="col-span-12 md:col-span-3">
        <label class="block text-sm font-medium mb-1">Observação</label>
        <input
          [(ngModel)]="itemObservation"
          pInputText
          type="text"
          class="w-full"
          placeholder="Opcional"
        />
      </div>
      <div class="col-span-12 md:col-span-1">
        <button
          type="button"
          (click)="adicionarItemComanda()"
          [disabled]="!selectedProduct || loadingAddItem"
          class="w-full py-2 rounded bg-orange-600 text-white text-sm hover:bg-orange-700 disabled:opacity-50"
        >
          +
        </button>
      </div>
    </div>

    <p-table [value]="comandaForEdit.items" [paginator]="false" styleClass="p-datatable-sm p-datatable-gridlines" class="text-sm" tabindex="-1">
      <ng-template pTemplate="header">
        <tr class="bg-gray-100">
          <th class="text-left p-2">Produto</th>
          <th class="text-right p-2">Qtd</th>
          <th class="text-right p-2">Unit.</th>
          <th class="text-right p-2">Total</th>
          <th class="text-center p-2">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="p-2">{{ item.productName || '-' }}</td>
          <td class="text-right p-2">{{ item.quantity | number:'1.0-2' }}</td>
          <td class="text-right p-2">{{ item.unitPrice | currency:'BRL' }}</td>
          <td class="text-right p-2">{{ item.total | currency:'BRL' }}</td>
          <td class="p-2">
            <div class="flex items-center justify-center gap-1">
              <button
                type="button"
                (click)="alterarQuantidadeItem(item, item.quantity - 1)"
                [disabled]="loadingChangeItem"
                class="px-2 py-1 rounded bg-yellow-500 text-white hover:bg-yellow-600 disabled:opacity-50"
              >
                -
              </button>
              <button
                type="button"
                (click)="alterarQuantidadeItem(item, item.quantity + 1)"
                [disabled]="loadingChangeItem"
                class="px-2 py-1 rounded bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
              >
                +
              </button>
              <button
                type="button"
                (click)="removerItemComanda(item.id)"
                [disabled]="loadingChangeItem"
                class="px-2 py-1 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
              >
                Remover
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="5" class="text-center p-4 text-gray-500">Nenhum item na comanda.</td></tr>
      </ng-template>
    </p-table>

    <div class="flex justify-between items-center border-t pt-2 font-semibold" tabindex="-1">
      <span>Total da comanda</span>
      <span>{{ comandaForEdit.total | currency:'BRL' }}</span>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" pButton label="Fechar" class="p-button-secondary" (click)="closeAddItemsModal()" tabindex="-1"></button>
  </ng-template>
</p-dialog>
